export enum ActivityLogOperationTypeEnum {
  // Create Operations
  CreateFile = 'CreateFile', // Creating a new file
  CreateFolder = 'CreateFolder', // Creating a new folder
  CreateFileFailed = 'CreateFileFailed', // Failed attempt to create a new file
  CreateFolderFailed = 'CreateFolderFailed', // Failed attempt to create a new folder

  // Read Operations
  ReadFile = 'ReadFile', // Reading a file
  ReadFolder = 'ReadFolder', // Reading a folder
  DownloadFile = 'DownloadFile', // Downloading a file
  DownloadFileEncrypted = 'DownloadFileEncrypted', // Downloading a file in encrypted form
  DownloadFileZip = 'DownloadFileZip', // Downloading a file compressed in Zip mode
  SearchFiles = 'SearchFiles', // Searching Files
  ReadFileFailed = 'ReadFileFailed', // Failed attempt to read a file
  ReadFolderFailed = 'ReadFolderFailed', // Failed attempt to read a folder
  DownloadFileFailed = 'DownloadFileFailed', // Failed attempt to download a file
  DownloadFileEncFailed = 'DownloadFileEncFailed', // Failed attempt to download a encrypted file
  DownloadFileZipFailed = 'DownloadFileZipFailed', // Failed attempt to download a zip file

  // Update Operations
  UpdateFile = 'UpdateFile', // Updating an existing file
  RenameFile = 'RenameFile', // Renaming a file
  MoveFile = 'MoveFile', // Moving a file to a different location
  DuplicateFile = 'DuplicateFile', // Copying a file
  UploadFile = 'UploadFile', // Upload new file
  UpdateFileFailed = 'UpdateFileFailed', // Failed attempt to update a file
  RenameFileFailed = 'RenameFileFailed', // Failed attempt to rename a file
  MoveFileFailed = 'MoveFileFailed', // Failed attempt to move a file
  DuplicateFileFailed = 'DuplicateFileFailed', // Failed attempt to copy a file
  UploadFileFailed = 'UploadFileFailed', // Failed attempt to upload a file

  // Delete Operations
  DeleteFileToRecycleBin = 'DeleteFileToRecycleBin', // Deleting a file to the recycle bin
  DeleteFolderToRecycleBin = 'DeleteFolderToRecycleBin', // Deleting a folder to the recycle bin
  DeleteFileToRecycleBinFailed = 'DeleteFileToRecycleBinFailed', // Failed attempt to delete a file to the recycle bin
  DeleteFolderToRecycleBinFailed = 'DeleteFolderToRecycleBinFailed', // Failed attempt to delete a folder to the recycle bin

  // Permanent Deletions
  DeleteFilePermanently = 'DeleteFilePermanently', // Permanently deleting a file
  DeleteFolderPermanently = 'DeleteFolderPermanently', // Permanently deleting a folder
  DeleteFilePermanentlyFailed = 'DeleteFilePermanentlyFailed', // Failed attempt to permanently delete a file
  DeleteFolderPermanentlyFailed = 'DeleteFolderPermanentlyFailed', // Failed attempt to permanently delete a folder

  // Share Operations
  ShareFile = 'ShareFile', // Sharing a file
  ShareFolder = 'ShareFolder', // Sharing a folder
  RevokeShare = 'RevokeShare', // Revoking a share
  ShareFileFailed = 'ShareFileFailed', // Failed attempt to share a file
  ShareFolderFailed = 'ShareFolderFailed', // Failed attempt to share a folder
  RevokeShareFailed = 'RevokeShareFailed', // Failed attempt to revoke a share

  // Audit
  ViewAuditLog = 'ViewAuditLog', // Viewing the audit log
  ExportAuditLog = 'ExportAuditLog', // Exporting the audit log
  ViewAuditLogFailed = 'ViewAuditLogFailed', // Failed attempt to view the audit log
  ExportAuditLogFailed = 'ExportAuditLogFailed', // Failed attempt to export the audit log
  PurgeAuditLog = 'PurgeAuditLog', // Automatic purge of expired audit log rows (ACTIVITY_LOG_RETENTION)

  // Access Control Operations
  GrantAccess = 'GrantAccess', // Granting access to a user or group
  RevokeAccess = 'RevokeAccess', // Revoking access from a user or group
  GrantAccessFailed = 'GrantAccessFailed', // Failed attempt to grant access
  RevokeAccessFailed = 'RevokeAccessFailed', // Failed attempt to revoke access

  // Versioning Operations
  CreateVersion = 'CreateVersion', // Creating a new version of a file
  RevertVersion = 'RevertVersion', // Reverting to a previous version of a file
  CreateVersionFailed = 'CreateVersionFailed', // Failed attempt to create a new version
  RevertVersionFailed = 'RevertVersionFailed', // Failed attempt to revert to a previous version

  // Collaboration Operations
  CommentFile = 'CommentFile', // Commenting on a file
  ReplyComment = 'ReplyComment', // Replying to a comment on a file
  AssignTask = 'AssignTask', // Assigning a task related to a file
  CommentFileFailed = 'CommentFileFailed', // Failed attempt to comment on a file
  ReplyCommentFailed = 'ReplyCommentFailed', // Failed attempt to reply to a comment
  AssignTaskFailed = 'AssignTaskFailed', // Failed attempt to assign a task

  // Miscellaneous Operations
  PreviewFile = 'PreviewFile', // Previewing a file
  HiddenFile = 'HiddenFile', // Hidden a file
  UnhiddenFile = 'UnhiddenFile', // Unhidden a file
  AddToFavorites = 'AddToFavorites', // Adding a file to favorites
  RemoveFromFavorites = 'RemoveFromFavorites', // Removing a file from favorites
  PreviewFileFailed = 'PreviewFileFailed', // Failed attempt to preview a file
  HiddenFileFailed = 'HiddenFileFailed', // Failed attempt to hidden a file
  UnhiddenFileFailed = 'UnhiddenFileFailed', // Failed attempt to unhidden a file
  AddToFavoritesFailed = 'AddToFavoritesFailed', // Failed attempt to add to favorites
  RemoveFromFavoritesFailed = 'RemoveFromFavoritesFailed', // Failed attempt to remove from favorites

  // Admin Operations
  CreateUser = 'CreateUser', // Creating a new user
  EditUser = 'EditUser', // Editing an existing user
  RemoveUser = 'RemoveUser', // Removing a user
  CreateGroup = 'CreateGroup', // Creating a new group
  EditGroup = 'EditGroup', // Editing an existing group
  RemoveGroup = 'RemoveGroup', // Removing a group
  OnBehalfOfAccess = 'OnBehalfOfAccess', // Accessing on behalf of another user
  OnBehalfOfOperation = 'OnBehalfOfOperation', // Operating on behalf of another user
  CreateUserFailed = 'CreateUserFailed', // Failed attempt to create a user
  EditUserFailed = 'EditUserFailed', // Failed attempt to edit a user
  RemoveUserFailed = 'RemoveUserFailed', // Failed attempt to remove a user
  CreateGroupFailed = 'CreateGroupFailed', // Failed attempt to create a group
  EditGroupFailed = 'EditGroupFailed', // Failed attempt to edit a group
  RemoveGroupFailed = 'RemoveGroupFailed', // Failed attempt to remove a group
  OnBehalfOfAccessFailed = 'OnBehalfOfAccessFailed', // Failed attempt to access on behalf of another user
  OnBehalfOfOperationFailed = 'OnBehalfOfOperationFailed', // Failed Operating on behalf of another user

  // Members Access
  LogIn = 'LogIn', // Logging in
  LogOut = 'LogOut', // Logging out
  LastCheckToken = 'LastCheckToken', // Last Check Activity Token
  OTPRequest = 'OTPRequest', // OTP Request
  LogInFailed = 'LogInFailed', // Failed attempt to log in
  LogOutFailed = 'LogOutFailed', // Failed attempt to log out
  OTPRequestFailed = 'OTPRequestFailed', // Failed attempt to otp request

  // Tags Operations
  AddTag = 'AddTag', // Adding a tag to a file
  RemoveTag = 'RemoveTag', // Removing a tag from a file
  UpdateTag = 'UpdateTag', // Updating a tag on a file
  ListTags = 'ListTags', // Listing all tags for a file
  AddTagFailed = 'AddTagFailed', // Failed attempt to add a tag to a file
  RemoveTagFailed = 'RemoveTagFailed', // Failed attempt to remove a tag from a file
  UpdateTagFailed = 'UpdateTagFailed', // Failed attempt to update a tag on a file
  ListTagsFailed = 'ListTagsFailed', // Failed attempt to list all tags for a file

  // Additional Operations
  RestoreFile = 'RestoreFile', // Restoring a deleted file
  TagFile = 'TagFile', // Adding tags to a file
  RemoveTagFile = 'RemoveTagFile', // Removing tags from a file
  EncryptFile = 'EncryptFile', // Encrypting a file
  DecryptFile = 'DecryptFile', // Decrypting a file
  ChangeFileOwner = 'ChangeFileOwner', // Changing the owner of a file
  SetFileExpiration = 'SetFileExpiration', // Setting an expiration date for a file
  GenerateShareLink = 'GenerateShareLink', // Generating a share link
  ValidateUser = 'ValidateUser', // Validating a user (e.g., for 2FA)
  SignFile = 'SignFile', // Sign a file with digital signature
  FileDescription = 'FileDescription', // Setting file Description
  ShortCut = 'ShortCut', // Generation a file shortcut

  RestoreFileFailed = 'RestoreFileFailed', // Failed attempt to restore a file
  TagFileFailed = 'TagFileFailed', // Failed attempt to add tags to a file
  RemoveTagFileFailed = 'RemoveTagFileFailed', // Failed attempt to remove tags from a file
  EncryptFileFailed = 'EncryptFileFailed', // Failed attempt to encrypt a file
  DecryptFileFailed = 'DecryptFileFailed', // Failed attempt to decrypt a file
  ChangeFileOwnerFailed = 'ChangeFileOwnerFailed', // Failed attempt to change the owner of a file
  SetFileExpirationFailed = 'SetFileExpirationFailed', // Failed attempt to set an expiration date
  GenerateShareLinkFailed = 'GenerateShareLinkFailed', // Failed attempt to generate a share link
  ValidateUserFailed = 'ValidateUserFailed', // Failed attempt to validate a user
  SignFileFailed = 'SignFileFailed', // Failed attempt to sign a file with digital signature
  FileDescriptionFailed = 'FileDescriptionFailed', // Failed attempt to setting file Description
  ShortCutFailed = 'ShortCutFailed', // Failed attempt to create file short cut

  // Security and Monitoring
  ScreenCaptureAttempt = 'ScreenCaptureAttempt', // Attempt to capture the screen
  ClipboardCopyAttempt = 'ClipboardCopyAttempt', // Attempt to copy to clipboard
  UnauthorizedAccessAttempt = 'UnauthorizedAccessAttempt', // Unauthorized access attempt
  ScreenCaptureAttemptFailed = 'ScreenCaptureAttemptFailed', // Failed attempt to capture the screen
  ClipboardCopyAttemptFailed = 'ClipboardCopyAttemptFailed', // Failed attempt to copy to clipboard
  UnauthorizedAccessAttemptFailed = 'UnauthorizedAccessAttemptFailed', // Failed unauthorized access attempt
  MalwareDetection = 'MalwareDetection', // Detection of malware
  MalwareRemoval = 'MalwareRemoval', // Removal of detected malware
  SuspiciousActivityDetected = 'SuspiciousActivityDetected', // Detection of suspicious activity
  IntrusionDetection = 'IntrusionDetection', // Detection of an intrusion attempt
  IntrusionPrevention = 'IntrusionPrevention', // Prevention of an intrusion attempt
  DataLeakageAttempt = 'DataLeakageAttempt', // Attempt to leak data
  DataLeakageAttemptFailed = 'DataLeakageAttemptFailed', // Failed attempt to leak data
  PhishingAttemptDetected = 'PhishingAttemptDetected', // Detection of a phishing attempt
  RansomwareAttackDetected = 'RansomwareAttackDetected', // Detection of a ransomware attack
  BruteForceAttackDetected = 'BruteForceAttackDetected', // Detection of a brute force attack
  TwoFactorAuthEnabled = 'TwoFactorAuthEnabled', // Enabling two-factor authentication
  TwoFactorAuthDisabled = 'TwoFactorAuthDisabled', // Disabling two-factor authentication
  TwoFactorAuthAttemptFailed = 'TwoFactorAuthAttemptFailed', // Failed attempt for two-factor authentication
  PasswordChange = 'PasswordChange', // Changing a password
  PasswordChangeFailed = 'PasswordChangeFailed', // Failed attempt to change a password
  SecuritySettingsUpdate = 'SecuritySettingsUpdate', // Updating security settings
  SecuritySettingsUpdateFailed = 'SecuritySettingsUpdateFailed', // Failed attempt to update security settings
  FirewallRuleChange = 'FirewallRuleChange', // Changing a firewall rule
  FirewallRuleChangeFailed = 'FirewallRuleChangeFailed', // Failed attempt to change a firewall rule
  EncryptionKeyManagement = 'EncryptionKeyManagement', // Managing encryption keys
  EncryptionKeyManagementFailed = 'EncryptionKeyManagementFailed', // Failed attempt to manage encryption keys
  AccessControlPolicyChange = 'AccessControlPolicyChange', // Changing access control policies
  AccessControlPolicyChangeFailed = 'AccessControlPolicyChangeFailed', // Failed attempt to change access control policies
  SecurityPatchApplied = 'SecurityPatchApplied', // Applying a security patch
  SecurityPatchAppliedFailed = 'SecurityPatchAppliedFailed', // Failed attempt to apply a security patch

  // EmailGrant Operations
  EmailSent = 'EmailSent', // Email sent to recipients
  EmailRead = 'EmailRead', // Email opened/read by recipient
  EmailSaveDraft = 'EmailSaveDraft', // Draft saved
  EmailUpdateDraft = 'EmailUpdateDraft', // Draft updated
  EmailTrash = 'EmailTrash', // Email moved to trash
  EmailRestore = 'EmailRestore', // Email restored from trash
  EmailDelete = 'EmailDelete', // Email permanently deleted
  EmailArchive = 'EmailArchive', // Email archived
  EmailUnarchive = 'EmailUnarchive', // Email unarchived
  EmailFavourite = 'EmailFavourite', // Email marked as favourite
  EmailUnfavourite = 'EmailUnfavourite', // Email unmarked as favourite
  EmailAttachmentRemoved = 'EmailAttachmentRemoved', // Attachment removed from sent email
  EmailRecipientRemoved = 'EmailRecipientRemoved', // Recipient removed from sent email
  EmailReplied = 'EmailReplied', // Email reply sent
  EmailForwarded = 'EmailForwarded', // Email forwarded to new recipients

  // Settings Management
  CreateSetting = 'CreateSetting', // Creating a new setting
  UpdateSetting = 'UpdateSetting', // Updating an existing setting
  DeleteSetting = 'DeleteSetting', // Deleting a setting

  // Payment Operations
  PaymentSessionCreated = 'PaymentSessionCreated', // Stripe checkout session created
  PaymentCompleted = 'PaymentCompleted', // Payment completed and file purchased

  // Session Management
  SessionRevoked = 'SessionRevoked', // Single session/token revoked
  AllSessionsRevoked = 'AllSessionsRevoked', // All user sessions revoked (logout everywhere)
  AdminSessionRevoked = 'AdminSessionRevoked', // Admin revoked user session

  // BackOffice Operations
  CreateCompany = 'CreateCompany', // Creating a new company/tenant
  UpdateCompany = 'UpdateCompany', // Updating company configuration
  BackOfficeCreateUser = 'BackOfficeCreateUser', // Creating user via backoffice
  BackOfficeUpdateUser = 'BackOfficeUpdateUser', // Updating user via backoffice
  SystemMaintenance = 'SystemMaintenance', // System maintenance operations (closure table rebuild, etc.)

  // Access Rules & Certificates
  CreateCertificate = 'CreateCertificate', // Creating RSA certificate for enterprise access
  CreateAccessRule = 'CreateAccessRule', // Creating access control rule

  // File Version Operations
  VersionRetention = 'VersionRetention', // Marking file versions as deleted by retention policy
  CleanupDeletedVersions = 'CleanupDeletedVersions', // Permanently deleting old file versions from storage

  // SSO Operations
  CreateIdentityProvider = 'CreateIdentityProvider', // Creating identity provider (Microsoft, Google, etc.)
  UpdateIdentityProvider = 'UpdateIdentityProvider', // Updating identity provider configuration

  // AI Agent Operations
  CreateAIAgent = 'CreateAIAgent', // Creating new AI classification agent
  UpdateAIAgent = 'UpdateAIAgent', // Updating AI agent configuration
  DeleteAIAgent = 'DeleteAIAgent', // Deleting AI agent

  // AI Chat Operations
  AIChatRequest = 'AIChatRequest', // User sent a prompt to AI chat
  AIChatWithDocument = 'AIChatWithDocument', // User sent a prompt to chat with specific document
  AIChatDeleteConversation = 'AIChatDeleteConversation', // User deleted an AI chat conversation

  // Batch Operations
  CancelBatch = 'CancelBatch', // Cancelling a batch operation
  CancelFileJobs = 'CancelFileJobs', // Cancelling specific file jobs in a batch
  RetryFileJobs = 'RetryFileJobs', // Retrying failed file jobs

  // Notification Operations
  InviteUsers = 'InviteUsers', // Sending invitation emails to users

  // Executive Report Operations
  ViewExecutiveReport = 'ViewExecutiveReport', // Viewing executive report (security-sensitive)

  // View List Operations (meta-audit for data access tracking)
  ViewUsersList = 'ViewUsersList', // Viewing users list
  ViewGroupsList = 'ViewGroupsList', // Viewing groups list
  ViewSettings = 'ViewSettings', // Viewing settings
  ViewTrash = 'ViewTrash', // Viewing trash/recycle bin
  ViewArchivedFiles = 'ViewArchivedFiles', // Viewing archived files
  ViewFavoriteFiles = 'ViewFavoriteFiles', // Viewing favorite files
  ViewSharedFiles = 'ViewSharedFiles', // Viewing shared files
  ViewReceivedFiles = 'ViewReceivedFiles', // Viewing received files

  // Public Link Operations
  CreatePublicLink = 'CreatePublicLink', // Creating a public shareable link
  RevokePublicLink = 'RevokePublicLink', // Revoking a public link
  PublicLinkAccess = 'PublicLinkAccess', // Anonymous access to public link (view info)
  PublicLinkDownload = 'PublicLinkDownload', // Anonymous download via public link
  PublicLinkViewerAccess = 'PublicLinkViewerAccess', // Anonymous file viewer access via public link
  PublicLinkAccessFailed = 'PublicLinkAccessFailed', // Failed access attempt (expired, revoked, wrong password)

  // IP/Region Restriction Operations
  IpRegionLoginBlocked = 'IpRegionLoginBlocked', // Login blocked by IP/Region restriction
  IpRegionFileOperationBlocked = 'IpRegionFileOperationBlocked', // File operation blocked by IP/Region restriction

  // Entra ID Sync Operations
  EntraIdSyncStarted = 'EntraIdSyncStarted', // Entra ID synchronization started
  EntraIdSyncCompleted = 'EntraIdSyncCompleted', // Entra ID synchronization completed
  EntraIdUserImported = 'EntraIdUserImported', // User imported from Entra ID
  EntraIdGroupImported = 'EntraIdGroupImported', // Group imported from Entra ID
  EntraIdSyncFailed = 'EntraIdSyncFailed', // Entra ID synchronization failed

  // Directory sync (Entra ID + Active Directory) — safety / AD audit ops
  DirectorySyncUserDisabled = 'DirectorySyncUserDisabled',
  DirectorySyncUserEnabled = 'DirectorySyncUserEnabled',
  DirectorySyncGroupMembersChanged = 'DirectorySyncGroupMembersChanged',
  DirectorySyncStarted = 'DirectorySyncStarted',
  DirectorySyncCompleted = 'DirectorySyncCompleted',
  DirectorySyncFailed = 'DirectorySyncFailed',
  DirectorySyncUserImported = 'DirectorySyncUserImported',
  DirectorySyncGroupImported = 'DirectorySyncGroupImported',
  DirectorySyncConnectionTested = 'DirectorySyncConnectionTested',

  // Folder Password Operations
  SetFolderPassword = 'SetFolderPassword', // Password protection set on folder
  RemoveFolderPassword = 'RemoveFolderPassword', // Password protection removed from folder
  FolderPasswordVerified = 'FolderPasswordVerified', // Folder password successfully verified
  FolderPasswordFailed = 'FolderPasswordFailed', // Folder password verification failed
  FolderPasswordLockout = 'FolderPasswordLockout', // User locked out due to too many failed attempts
  FolderPasswordSessionRevoked = 'FolderPasswordSessionRevoked', // Folder password session revoked

  // Folder Password Reset OTP Operations
  FolderPasswordResetOtpRequested = 'FolderPasswordResetOtpRequested', // OTP requested for folder password reset
  FolderPasswordResetWithOtp = 'FolderPasswordResetWithOtp', // Folder password reset via OTP
  FolderPasswordResetOtpFailed = 'FolderPasswordResetOtpFailed', // Failed OTP verification for folder password reset

  // TOTP Exemption Operations
  TotpExemptionGranted = 'TotpExemptionGranted', // Admin granted TOTP exemption for a user
  TotpExemptionRevoked = 'TotpExemptionRevoked', // Admin revoked TOTP exemption for a user
  TotpExemptionExpired = 'TotpExemptionExpired', // TOTP exemption expired automatically

  // Ownership Transfer Operations
  TransferOwnership = 'TransferOwnership', // Transferring ownership of files from one user to another
  TransferOwnershipFailed = 'TransferOwnershipFailed', // Failed attempt to transfer ownership

  // User Login Token Operations
  UserLoginTokenCreated = 'UserLoginTokenCreated', // Admin created a login token for a user
  UserLoginTokenDeleted = 'UserLoginTokenDeleted', // Admin deleted a login token for a user
  UserLoginTokenStatusChanged = 'UserLoginTokenStatusChanged', // Admin enabled/disabled a login token
  UserLoginTokenUsed = 'UserLoginTokenUsed', // User logged in using a login token
  UserLoginTokenFailed = 'UserLoginTokenFailed', // Failed login attempt with a login token

  // Passkey (WebAuthn/FIDO2) Operations
  PasskeyRegistered = 'PasskeyRegistered', // User registered a new passkey credential
  PasskeyRemoved = 'PasskeyRemoved', // User removed a passkey credential
  PasskeyRemovedByAdmin = 'PasskeyRemovedByAdmin', // Admin force-removed a user's passkey
  PasskeyAuthenticationFailed = 'PasskeyAuthenticationFailed', // Failed passkey authentication attempt
  PasskeyPasswordlessLogin = 'PasskeyPasswordlessLogin', // Successful passwordless login via passkey
  PasskeyBlocked = 'PasskeyBlocked', // User blocked due to too many failed passkey attempts

  // SharePoint Integration (SharePointGrant) Operations
  // The scan rows are system rows (UserId = 0, TargetId = 0) and there is ONE row per encrypted
  // file: a first pass over a large tenant produces tens of thousands of them.
  SharePointFileEncrypted = 'SharePointFileEncrypted', // A SharePoint file was encrypted in place by the scan
  SharePointFileEncryptionFailed = 'SharePointFileEncryptionFailed', // The scan gave up on a SharePoint file after the retry limit
  SharePointFileEncryptionSkipped = 'SharePointFileEncryptionSkipped', // File claims our encrypted format but Filegrant never encrypted it
  SharePointScanCycleCompleted = 'SharePointScanCycleCompleted', // A scan cycle finished for a company (summary row)
  SharePointScanCycleFailed = 'SharePointScanCycleFailed', // A scan cycle threw for a company (the others kept going)
  SharePointConnectionTested = 'SharePointConnectionTested', // Admin verified the SharePoint credentials (POST /connection/test)
  SharePointConnectionTestFailed = 'SharePointConnectionTestFailed', // That verification was refused by Graph
  SharePointPerimeterBrowsed = 'SharePointPerimeterBrowsed', // Admin enumerated the customer sites/libraries/folders
  SharePointViewerTokenIssued = 'SharePointViewerTokenIssued', // A viewer token carrying the key of ONE encrypted SharePoint file was issued
  SharePointViewerTokenDenied = 'SharePointViewerTokenDenied', // That request was refused (not our file, wrong tenant, SharePoint said no)
  SharePointEditSessionOpened = 'SharePointEditSessionOpened', // An editing session was opened on an encrypted SharePoint file (read-only or writable)
  SharePointEditSessionDenied = 'SharePointEditSessionDenied', // That request was refused (not our file, wrong tenant, SharePoint said no, not editable)
  SharePointFileEdited = 'SharePointFileEdited', // An editing session saved a SharePoint file: decrypted, edited, re-encrypted in place
}
